import { useCallback, useEffect, useMemo } from 'react';
import useContacts from './useContacts';
import { createGlobalState } from 'react-hooks-global-state';
import useStorageContext from './useStorageContext';
const KEY_NAME = 'contact-groups';
const { useGlobalState } = createGlobalState({ contactGroups: null });
export default function useContactGroups() {
    const storage = useStorageContext();
    const { contacts } = useContacts();
    const [state, setState] = useGlobalState('contactGroups');
    useEffect(() => {
        if (state) {
            const mapped = state.map(({ members, name }) => ({
                members: members.map(({ email }) => email),
                name
            }));
            const str = JSON.stringify(mapped);
            storage.setItem(KEY_NAME, str);
            return;
        }
        const str = storage.getItem(KEY_NAME);
        if (str) {
            if (contacts) {
                const mapped = JSON.parse(str);
                const s = mapped.map(({ members, name }) => ({
                    members: members
                        .map((email) => contacts.find((c) => c.email === email))
                        .filter((c) => c !== undefined),
                    name
                }));
                setState(s);
            }
        }
        else {
            setState([]);
        }
    }, [contacts, setState, state, storage]);
    const addContactGroup = useCallback(async (group) => {
        if (!state) {
            setState([group]);
            return;
        }
        if (state.find((g) => g.name === group.name)) {
            return;
        }
        const updated = state.concat([group]);
        setState(updated);
    }, [setState, state]);
    const removeContactGroup = useCallback((group) => {
        if (!state) {
            return;
        }
        const index = state.findIndex((g) => g.name === group.name);
        if (index >= 0) {
            const updated = state.slice(0);
            updated.splice(index, 1);
            setState(updated);
        }
    }, [setState, state]);
    return useMemo(() => ({
        addContactGroup,
        contactGroups: state,
        removeContactGroup,
        setContactGroups: setState
    }), [addContactGroup, removeContactGroup, setState, state]);
}
